import type { ConsultationResponseDto } from '@montugroup/pms-api-contracts';
import { useQuery } from '@tanstack/react-query';

import { getTsPatientPortalClient } from '@montugroup/circuit-shared/api/patient-portal.client';

interface UseConsultationsParams {
  when: 'completed' | 'upcoming';
  page?: {
    before?: string;
    after?: string;
    size: number;
  };
  /** polls the list every this many ms */
  refetchInterval?: number | false;
}

const client = getTsPatientPortalClient();

const useGetConsultations = ({ when, page, refetchInterval }: UseConsultationsParams) => {
  const { data, isLoading, error, isError, isSuccess, refetch, isFetching } = useQuery({
    queryKey: ['consultations', when, page],
    queryFn: async () => {
      const response = await client.getConsultations.query({
        query: { when, page },
      });
      if (response.status !== 200) {
        throw new Error((response.body as { error: { message: string } }).error.message);
      }

      return response.body.data;
    },
    staleTime: 1000 * 60 * 1, // 1 min
    refetchInterval,
  });

  const consultData: ConsultationResponseDto[] = data || [];

  return { consultData, isLoading, error, isError, isSuccess, refetch, isFetching };
};

export default useGetConsultations;
